export function pxToRem(px: number) {
  return `${px / 16}rem`;
}
